import { CardChallenge } from "Components/Shared/Challenge/CardChallenge/CardChallenge";
import type { LoyaltyEventDto } from "Infrastructure/Api/Api";
import { CardChallengeSkeleton } from "Components/Shared/Challenge/CardChallenge/CardChallengeSkeleton";
import { Grid } from "@mui/material";

type Props = {
  challenges: Array<LoyaltyEventDto>;
  isLoading: boolean;
};

export const CardChallenges = ({ challenges, isLoading }: Props) => (
  <Grid container spacing={2}>
    {isLoading ? (
      <CardChallengesSkeleton />
    ) : (
      challenges.map(
        ({ code, points, progress, isCompleted, loyaltyPointType }) => (
          <Grid key={code} size={{ xs: 6, sm: 4, md: 4 }}>
            <CardChallenge
              event={code}
              points={points}
              progressPercent={progress || 0}
              isCompleted={isCompleted}
              loyaltyPointType={loyaltyPointType}
            />
          </Grid>
        ),
      )
    )}
  </Grid>
);

const CardChallengesSkeleton = () => (
  <>
    <Grid size={{ xs: 6, sm: 4, md: 4 }}>
      <CardChallengeSkeleton />
    </Grid>
    <Grid size={{ xs: 6, sm: 4, md: 4 }}>
      <CardChallengeSkeleton />
    </Grid>
    <Grid size={{ xs: 6, sm: 4, md: 4 }}>
      <CardChallengeSkeleton />
    </Grid>
  </>
);
